import { useEffect, useRef } from 'react'

interface VideoLightboxProps {
    open: boolean
    onClose: () => void
}

// Full-screen reel player that opens when a reel circle is clicked.
export function VideoLightbox({ open, onClose }: VideoLightboxProps) {
    const videoRef = useRef<HTMLVideoElement>(null)

    useEffect(() => {
        if (!open) return

        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose()
        }
        document.addEventListener('keydown', onKey)
        document.body.style.overflow = 'hidden'

        const video = videoRef.current
        if (video) {
            video.currentTime = 0
            video.play().catch(() => {})
        }

        return () => {
            document.removeEventListener('keydown', onKey)
            document.body.style.overflow = ''
            if (video) video.pause()
        }
    }, [open, onClose])

    if (!open) return null

    return (
        <div
            role='dialog'
            aria-modal='true'
            aria-label='Showreel'
            onClick={onClose}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 200,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '5vw',
                backgroundColor: 'rgba(0,0,0,0.92)'
            }}
        >
            <button
                type='button'
                onClick={onClose}
                aria-label='Close showreel'
                style={{
                    position: 'absolute',
                    top: '2rem',
                    right: '2rem',
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    border: 'none',
                    background: '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <img src='/images/Icon.svg' alt='' style={{ width: 18 }} />
            </button>
            <video
                ref={videoRef}
                controls
                playsInline
                onClick={(e) => e.stopPropagation()}
                poster='/videos/pexels-google-deepmind-video-poster-00001.jpg'
                style={{
                    width: '100%',
                    maxWidth: 1100,
                    maxHeight: '82vh',
                    borderRadius: 12,
                    background: '#000'
                }}
            >
                <source
                    src='/videos/pexels-google-deepmind-video-transcode.mp4'
                    type='video/mp4'
                />
                <source
                    src='/videos/pexels-google-deepmind-video-transcode.webm'
                    type='video/webm'
                />
            </video>
        </div>
    )
}
